import { Anchor, Badge, Card, CopyButton, Flex, Tooltip } from '@mantine/core';
import { IconHistory, IconPackage, IconRefresh } from '@tabler/icons-react';
import { useLocation } from 'react-router';
import prettifiedLabel from '../../constants/labelPrettifier';

const FacebookProductSetCard = ({ facebookProductSet }) => {
  const location = useLocation();

  return (
    <Card key={facebookProductSet.id} mb="md" withBorder>
      <Card.Section inheritPadding py="sm">
        <Anchor
          href={`#${location.pathname}/${facebookProductSet.id}/details`}
          fw={600}
          mb="xs"
          style={{ display: 'block' }}
        >
          {facebookProductSet.name}
        </Anchor>
        <Flex gap="xs" wrap="wrap">
          {facebookProductSet.status && (
            <Badge variant="default">
              <IconRefresh size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
              {prettifiedLabel('synchronised')}
            </Badge>
          )}
          {facebookProductSet.facebookProductCount != null && (
            <Badge variant="default">
              <IconPackage size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
              FB Products: {facebookProductSet.facebookProductCount}
            </Badge>
          )}
          {facebookProductSet.facebookProductSetId && (
            <CopyButton value={facebookProductSet.facebookProductSetId}>
              {({ copied, copy }) => (
                <Tooltip label={copied ? 'Copied' : 'Copy Meta product set id'} position="top" withArrow>
                  <Badge variant="default" style={{ cursor: 'pointer' }} onClick={copy}>
                    Meta ID: {facebookProductSet.facebookProductSetId}
                  </Badge>
                </Tooltip>
              )}
            </CopyButton>
          )}
          <Tooltip
            label={
              <>
                <div>Created: {new Date(facebookProductSet.createdAt).toLocaleString()}</div>
                <div>Updated: {new Date(facebookProductSet.updatedAt).toLocaleString()}</div>
              </>
            }
            position="top"
            withArrow
          >
            <Badge variant="default" style={{ cursor: 'pointer' }}>
              <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
            </Badge>
          </Tooltip>
        </Flex>
      </Card.Section>
    </Card>
  );
};

export default FacebookProductSetCard;
